<template lang="pug">
k-main.abmin-video()
</template>

<script lang="js">
import KMain from '@/blocks/k-main'
import WBtn from '@/widgets/w-btn'
import WBtnIcon from '@/widgets/w-btn-icon'

export default {
  name: 'AdminVideoPage',
  mixins: [],
  components: {
    KMain,
    WBtn,
    WBtnIcon
  },
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.admin-video {

}
</style>
